import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'wol-modal-delete',
  templateUrl: './modal-delete.component.html',
  styleUrls: ['./modal-delete.component.scss']
})
export class ModalDeleteComponent implements OnInit {

  @Input() type: string;
  @Input() title: string;
  @Input() text: string;
  @Input() objectlist: any[];

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

}
